import React, { useContext } from 'react';
import ButtonSeplag from '../../../../components/buttonSeplag/ButtonSeplag';
import { InputSwitch } from 'primereact/inputswitch';
import PageMessages from '../../../../config/translations/PageMessages';
import indicadorService from '../../../../service/IndicadorService';
import { useHistory } from 'react-router-dom';
import Pages from '../../../../config/Pages';
import { ApplicationContext } from '../../../../config/Router';

function ActionButtons({ data, confirmRef, modalInativarRef }) {
    const ativo = data?.situacaoIndicador?.codgSituacaoIndicador === 'ATIVO';
    const { refreshContext } = useContext(ApplicationContext);
    const history = useHistory();
    return (
        <>
            <ButtonSeplag
                tipo="info"
                type="button"
                tooltip="Visualizar"
                tooltipOptions={{ position: 'top' }}
                icon="pi pi-eye"
                onClick={() => {
                    refreshContext({});
                    history.push(Pages.sei.indicador.url.view.replace(':id', data.id));
                }}
            />
            <ButtonSeplag
                tipo="warning"
                type="button"
                tooltip="Editar"
                tooltipOptions={{ position: 'top' }}
                disabled={data?.situacaoIndicador?.codgSituacaoIndicador === 'INATIVO'}
                onClick={() => {
                    if (data?.situacaoIndicador?.codgSituacaoIndicador === 'EM_ALTERACAO') {
                        refreshContext({});
                        return history.push(Pages.sei.indicador.url.edit.replace(':id', data.id));
                    }
                    confirmRef.current?.show(PageMessages.sei.indicador.confirmAlter, async () => {
                        await indicadorService.alterarIndicador(data.id);
                        refreshContext({});
                        history.push(Pages.sei.indicador.url.edit.replace(':id', data.id));
                    });
                }}
                icon="pi pi-pencil"
                style={{ marginLeft: '.5em' }}
            />
            <InputSwitch
                checked={ativo}
                disabled={data?.situacaoIndicador?.codgSituacaoIndicador === 'EM_ALTERACAO'}
                tooltip={ativo ? 'Inativar' : 'Ativar'}
                tooltipOptions={{ position: 'top' }}
                style={{ marginLeft: '.5em', marginTop: '.5em' }}
                onChange={() => {
                    modalInativarRef.current?.show({ idIndicador: data?.id, ativar: !ativo });
                }}
            />
            <ButtonSeplag
                tipo="help"
                type="button"
                tooltip="Histórico"
                tooltipOptions={{ position: 'top' }}
                icon="pi pi-history"
                style={{ marginLeft: '.5em' }}
                onClick={() => {
                    refreshContext({});
                    history.push(
                        `${Pages.sei.historicoIndicador.url.list.replace(':id', data?.id)}`
                    );
                }}
            />
        </>
    );
}

export default ActionButtons;
